import { IconOffering } from '@purpur/library/icon/offering';
import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const LoginCtaContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${getPurpurSpacing('150')};
    padding: ${getPurpurSpacing('200')};
    background: ${getPurpurColor('backgroundToneOnToneSecondary')};
    color: ${getPurpurColor('textToneOnToneSecondary')};

    ${purpurMedia('lg')`
        padding: ${getPurpurSpacing('200')} ${getPurpurSpacing('600')};
    `}
`;

export const LoginCtaIcon = styled(IconOffering).attrs({ size: 'lg', 'aria-hidden': true })`
    flex-shrink: 0;

    ${purpurMedia('lg')`
        order: -1;
        height: ${getPurpurSpacing('300')};
        width: ${getPurpurSpacing('300')};
    `}
`;
